// The LulPay mark, hand-traced from design/logo-source/lulpay-logo-source-571.png (WU-2).
// Three shapes: the left arrowhead joined to the V chevron, the U with its round slot, and the right triangle.
// Straight edges are exact 0°, 45° or 90° lines; the slot bottom is the only curve.
// public/brand/*.svg and public/favicon.svg use these same paths (checked by brandAssets.test.ts).

/** viewBox tight around the mark, in the source frame. */
export const LOGO_VIEWBOX = '10.25 21 548.75 524.5';
export const LOGO_WIDTH = 548.75;
export const LOGO_HEIGHT = 524.5;

export const LOGO_PATHS: readonly string[] = [
  'M10.25 271.75 L118 164 L118 365 L198 365 L284 451 L370 365 L464.5 365 L284 545.5 Z',
  'M260 21 L260 283.5 A24 24 0 0 0 308 283.5 L308 21 L369.5 82.5 L369.5 311 L284 396.5 L198.5 311 L198.5 82.5 Z',
  'M452 164 L559 271 L520 310 L452 310 Z',
];

/** The app-icon composition: a square tile with the mark centred at this share of its width. */
export const TILE_SIZE = 512;
export const TILE_RADIUS = 112;
export const TILE_MARK_SHARE = 0.66;
